import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AcDocument, Apresentacao, Audits } from '../../models/apresentacao.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { ApresentacaoService } from '../../services/apresentacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-apresentacao-registro',
  templateUrl: './apresentacao-registro.component.html',
  styleUrls: ['./apresentacao-registro.component.scss']
})
export class ApresentacaoRegistroComponent extends BaseFormComponent<Apresentacao>   implements OnInit {

  id:number;
  filters: any;
  printMeeting: boolean = false;
  saving:boolean= false;
  audits:Audits[]= [];
  lastReport:AcDocument= null;
  loadAudits:boolean = true;
  @Input() print:boolean = false;
  @ViewChild('relatorio') relatorioRef!: ElementRef;
  
  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public myService: ApresentacaoService,
    private apresentacaoResolverId: ApresentacaoResolverId,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) {
    super(activatedRoute);
  }

  
  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.start();
  }

  start(){
    this.apresentacaoResolverId.getById( this.id ).subscribe({
        next: (data) => {
          this.entity = data;
          this.filters = data.filters;
          this.initForm();
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          console.log(error)
          this.msgError(error.error.message);
        }
    })
    this.myService.getReportHistoryData(this.id ).subscribe({
        next: (res) => {
          this.audits = res['audits'];
          this.lastReport = res['report'];
          this.loadAudits = false;
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError();
        },
    })
  }
  
  initForm() {
    this.form = new FormGroup({
      id: new FormControl(this.id),
      notes: new FormControl(null)
    });
    if (this.entity) {
      this.form = new FormGroup({
        id: new FormControl(this.id),
        notes: new FormControl(this.entity.acMeeting?.notes)
      });
    }
  }

  getDataCreate() {
    return Object.assign({}, this.form.value);
  }
  
  
  saveNotes(){
    if (this.form.valid) {
      this.loading();
      var newData = this.getDataCreate();
      this.myService.saveNotes(newData,this.id ).subscribe({
        next: (res) => {
          this.msgSuccess('Ata alterada com sucesso!');
          var data = this.entity;
          data['acMeeting']['notes'] = newData['notes'];
          sessionStorage.setItem('dataMeeting' + this.id, JSON.stringify(data));
          this.loaded();
        },
        error: (error) => {
          this.msgError(error.error.message);
          this.loaded();
        },
      });
    }
    else {
      this.markAsDirty();
    }
  }

  saveReport(){
    this.saving = true;
    this.printMeeting = true;
  }

  async generatePDF() {
    this.loaded();
    const element = document.querySelector('#relatorio');// agency-div
    if (element) {
      this.saveHtmlWithCss();
      this.printMeeting = false;
      return;
     /* document.fonts.ready.then(() => {
        const options = {
          margin: 5,
          filename: 'apresentacao-' + this.id + '.pdf',
          image: { type: 'jpeg', quality: 0.8 },//diminui de 0.98
          html2canvas: { scale: 1, useCORS: true, allowTaint: true  },//coloquei 1 em vez de 2
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: ['css'] } 
        };
        html2pdf().from(element).set(options).save();
        html2pdf().from(element).set(options).outputPdf('blob').then((pdfBlob: Blob) => {
          this.uploadPDF(pdfBlob);
        });
      })*/
        const batchSize = 10;
        const options = {
          margin: 5,
          filename: 'apresentacao-' + this.id + '.pdf',
          image: { type: 'jpeg', quality: 0.8 },
          html2canvas: { scale: 1, useCORS: true, allowTaint: true },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: ['css'] }
        };
        const sections = Array.from(document.querySelectorAll('.section'));
        let worker = html2pdf().set(options);
        console.log(sections)
        const processInBatches = async () => {
          for (let i = 0; i < sections.length; i ++) {
            const section = sections[i];
            const sectionInds = Array.from(section.querySelectorAll('.section-ind'));
            if (sectionInds.length > 0) {
              for (let j = 0; j < sectionInds.length; j += batchSize) {
                const batchContainer = document.createElement('div');
                const batch = sectionInds.slice(j, j + batchSize);
                batch.forEach(ss => batchContainer.appendChild(ss.cloneNode(true)));
                await worker.from(batchContainer).toContainer().toCanvas().toPdf().get('pdf').then((pdf) => {
                  if (j + 1 < sectionInds.length) {
                      pdf.addPage();
                  }
                  console.log(worker)
                });
              }
            }
            else{
              await worker.from(section).toContainer().toCanvas().toPdf().get('pdf').then((pdf) => {
                pdf.addPage();
                console.log(worker)
              });
            }
          
            
          };
          await worker.save();
      };
      await processInBatches();
    }
    this.printMeeting = false;
  }

  saveHtmlWithCss() {
    const element = document.querySelector('#relatorio');
    if (!element) return;
  
    const img = element.querySelector('img.apm-logo') as HTMLImageElement;
  
    if (!img) return;
  
    const imgSrc = img.src;
  
    fetch(imgSrc)
      .then(res => res.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Data = reader.result as string;
          img.src = base64Data; 
  
          this.generateAndDownloadHtml(element);
          img.src = imgSrc;
        };
        reader.readAsDataURL(blob);
      });
  }
  
  generateAndDownloadHtml(element) {
    const htmlContent = element.innerHTML;
  
    const styles = Array.from(document.styleSheets)
      .map(styleSheet => {
        try {
          return Array.from(styleSheet.cssRules)
            .map(rule => rule.cssText)
            .join('\n');
        } catch (e) {
          return '';
        }
      })
      .join('\n');
  
    const fontLinks = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .filter(link => (link as HTMLLinkElement).href.includes('fonts'))
      .map(link => `<link href="${(link as HTMLLinkElement).href}" rel="stylesheet">`)
      .join('\n');
  
    const fullHtml = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        ${fontLinks}
        <style>
        ${styles}
        </style>
      </head>
      <body>
        <div id="relatorio">
          ${htmlContent}
        </div>
      </body>
      </html>
    `;
  
    const blob = new Blob([fullHtml], { type: 'text/html' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'relatorio.html';
    a.click();
    URL.revokeObjectURL(a.href);
  
    this.uploadReport(blob);
  }
  
  uploadReport(pdfBlob: Blob) { 
    this.loading();
    const formData = new FormData();
    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const formattedDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    formData.append('file', pdfBlob,  `Relatorio_${formattedDate}.html`);
    this.myService.saveReport(this.id, formData).subscribe({
      next: (response) => {
        this.confirmation('Relatório salvo com sucesso').subscribe(() => {
          window.location.reload();
        })
      },
      error: (error) => {
        console.log(this.saving)
        this.loaded();
        this.msgError('Erro ao gerar relatório');
      }
    });
  }

  sendReport(){
    this.loading();
    this.myService.sendNotesMail(this.id).subscribe({
      next: (res) => {
        this.msgSuccess('Relatório enviado com sucesso!');
        this.loaded();
      },
      error: (error) => {
        this.msgError(error.error.message);
        this.loaded();
      },
    });
  }

  download(): void {
    this.loading();
    this.myService.downloadFile(this.lastReport?.id,'ac').subscribe({
      next: (res) => {
        this.downloadFile(res, this.lastReport.name);
      },
      error: (error) => {
        this.loaded();
        this.msgError('Arquivo não encontrado');
      },
    });
  }

  downloadFile(res, fileName:string) {
    const blob = new Blob([res.body], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
    this.loaded();
  }

}
